<template>
  <div>
    <div class="list-group mt-2">
      <div class="list-group-item">
        <div class="top-label d-flex flex-row justify-content-between mb-2">
          <span>Activity</span>
        </div>
        <div class="bars" ref="bars">
          <svg
            class="availability-time-line-graphic"
            preserveAspectRatio="none"
            height="34"
            :viewBox="`0 0 ${viewWidth} 34`"
          >
            <rect
              v-for="(item, i) in statBars"
              :key="i"
              height="34"
              :width="dim.width"
              :x="i*(dim.width+barSpace)"
              y="0"
              :fill="statColor(item.evaluation)"
              class=""
              data-html="true"
              data-toggle="tooltip" 
              data-placement="top" 
              title="Tooltip on top"
            />
          </svg>
        </div>
        <div class="bottom-label d-flex flex-row text-muted justify-content-between mb-2">
            <span>{{range}}</span>
            <span>{{dateObject.date}} {{dateObject.hour}}:{{dateObject.min}}{{dateObject.mer}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {convertDate} from '../../../filters/happroxy';

    export default {
        name: 'HowFarGraph',
        props: ['statBars', 'range'],
        data () {
          return {
            barSpace: 2,
            viewWidth: 0
          }
        },
        computed: {
          dim: function () {
            let count = this.$props.statBars.length
            let totalBarWidth = this.viewWidth - (this.barSpace*count)
            let eachBarWidth = totalBarWidth/count
            return {
              width: eachBarWidth > 5 ? 5 : eachBarWidth,
              heigth: 24
            }
          },
          dateObject: function () {
            const date = new Date()
            return {
              date: convertDate(date/1000),
              hour: date.getHours() > 12 ? date.getHours() - 12 : date.getHours(),
              min: date.getMinutes(),
              mer: date.getHours() > 12 ? "PM" : "AM"
            }
          }
        },
        mounted() {
          const _this = this
          _this.$nextTick(function(){
            _this.viewWidth = _this.$refs.bars.clientWidth
          })
        },
        methods: {
          statColor(evaluation){
            switch (evaluation) {
              case 1:
                return '#32cd32' 
                break;

              case 0:
                return 'orange'
                break;
            
              default:
                return '#cccccc'
                break;
            }
          }
        }

    }
</script>
